import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import {catchError, map} from "rxjs/operators"

@Injectable({
  providedIn: "root",
})
export class MulticideProvider {

  constructor(
    private httpClient: HttpClient
  ) {}

  createOffender(data: any): Observable<any> {
    return this.httpClient.post("/api/offender", data);
  }

  updateOffender(data: any): Observable<any> {
    return this.httpClient.put(`/api/offender/${data.id}`, data);
  }
  deleteOffender(userId: string): Observable<any> {
    return this.httpClient.delete(`/api/offender/${userId}`);
  }
  getValidValues() : Observable<any> {
    return this.httpClient.get("/api/offender/validvalues");
  }

  getAllForExport(): Observable<any> {
    return this.httpClient.get("/api/offender/allForExport", {});
  }

  getSPSS(file: any): Observable<any> {
    let headers = new HttpHeaders({
      "content-type": "multipart/form-data",
    })
    return this.httpClient.post(`/api/offender/spss`, file, {headers: headers, responseType: "blob"});
  }

  testPythonApi() : Observable<any> {
    return this.httpClient.get("/api/offender/testSPSS")
  }

  paginate(params: any): Observable<any> {
    return this.httpClient.get("/api/offender", {
      params,
    });
  }

  get(id: string): Observable<any> {
    return this.httpClient.get(`/api/offender/${id}`);
  }

  create(data: any): Observable<any> {
    return this.httpClient.post("/api/users", data);
  }

  update(userId: string, data: any): Observable<any> {
    return this.httpClient.put(`/api/users/${userId}`, data);
  }

  delete(userId: string): Observable<any> {
    return this.httpClient.delete(`/api/users/${userId}`);
  }

  logout(userId: string, tokenId: string): Observable<any> {
    return this.httpClient.post(`/api/users/${userId}/logout/${tokenId}`, null);
  }

  logoutAll(userId: string): Observable<any> {
    return this.httpClient.post(`/api/users/${userId}/logout`, null);
  }

  sendPasswordReset(userId: string): Observable<any> {
    return this.httpClient.post(`/api/users/${userId}/reset`, null);
  }

  sendVerificationEmail(userId: string): Observable<any> {
    return this.httpClient.post(`/api/users/${userId}/verify`, null);
  }

  sendInviteEmail(email: string): Observable<any> {
    return this.httpClient.post(`/api/users/invite`, {
      email,
    });
  }

  subscriptionUsage(userId: string): Observable<any> {
    return this.httpClient.get(`/api/users/${userId}/subscription/usage`);
  }

  subscriptionIncrementUsage(userId: string, featureId: string, increment: boolean): Observable<any> {
    return this.httpClient.post(`/api/users/${userId}/subscription/usage/${featureId}/increment`, {
      increment,
    });
  }

  subscriptionSetUsage(userId: string, featureId: string, count: number): Observable<any> {
    return this.httpClient.put(`/api/users/${userId}/subscription/usage/${featureId}`, {
      count,
    });
  }

}
